import React from 'react';

function PopupLogin({
  formData,
  errorMessage,
  showCodeInput,
  timer,
  maskedEmail,
  verificationCode,
  onChange,
  onSubmit,
  onVerificationCodeChange,
  onOpenRegistration,
  onVerifyCode,
  onClose
}) {
  return (
    <div className="popup__overlay">
      <div className="popup-login" onClick={(event) => event.stopPropagation()}>
        <h2 className="popup-login__heading">Для заказа войдите в личный кабинет</h2>
        <form className="popup-login__form" onSubmit={onSubmit}>
          <label>
            Номер телефона
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={onChange}
              placeholder="+7..."
              required
            />
          </label>
          {errorMessage && (
            <div className="error-message" style={{ color: 'red' }}>
              {errorMessage}
            </div>
          )}
          {!showCodeInput ? (
            <button className="popup-login__button popup-login__button-green" type="submit">
              Получить код
            </button>
          ) : (
            <>
              <p>Код действителен еще {timer} секунд</p>
              <p>Введите код, направленный на вашу почту: {maskedEmail}</p>
              <label>
                Секретный код
                <input
                  type="text"
                  value={verificationCode}
                  onChange={(event) => onVerificationCodeChange(event.target.value)}
                  placeholder="Введите код из письма здесь"
                  required
                />
              </label>
              <button className="popup-login__button" type="button" onClick={onOpenRegistration}>
                нет доступа к почте
              </button>
              <button
                className="popup-login__button popup-login__button-green"
                type="button"
                onClick={onVerifyCode}
              >
                Подтвердить
              </button>
            </>
          )}
          <button className="popup-login__button" type="button" onClick={onClose}>
            Отмена
          </button>
        </form>
      </div>
    </div>
  );
}

export default PopupLogin;
